import React from 'react';
import { useGetBookingsQuery } from '../../Bookings/Service/bookingsApi';
import type { Booking } from '../../Shared/Types/bookingTypes';
import {
  mapBookingToExpenseInvoiceLookup,
  type ExpenseInvoiceBookingLookup,
} from './expenseInvoiceBookingsLookupMapper';

type BookingsQueryResult = ReturnType<typeof useGetBookingsQuery>;

type ExpenseInvoiceBookingsLookupQueryResult = Pick<
  BookingsQueryResult,
  'isLoading' | 'isFetching' | 'isError' | 'error' | 'refetch'
> & {
  data: ExpenseInvoiceBookingLookup[];
};

export const useGetExpenseInvoiceBookingsLookupQuery =
  (): ExpenseInvoiceBookingsLookupQueryResult => {
    const queryResult = useGetBookingsQuery();

    const data = React.useMemo(
      () =>
        (queryResult.data ?? [])
          .map((booking: Booking) => mapBookingToExpenseInvoiceLookup(booking))
          .filter(
            (
              booking: ExpenseInvoiceBookingLookup | undefined
            ): booking is ExpenseInvoiceBookingLookup => Boolean(booking)
          ),
      [queryResult.data]
    );

    return {
      data,
      isLoading: queryResult.isLoading,
      isFetching: queryResult.isFetching,
      isError: queryResult.isError,
      error: queryResult.error,
      refetch: queryResult.refetch,
    };
  };
